import { render } from "./LinkookLiveFooter.vue?vue&type=template&id=020e8e76"
import script from "./LinkookLiveFooter.vue?vue&type=script&lang=js"
export * from "./LinkookLiveFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LinkookLiveFooter.vue?vue&type=style&index=0&id=020e8e76&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__